import api from '../../api/restaurant/restaurantOnboardingApi';
import {
  CustomResponse,
  RestaurantOnboardingStatus,
} from '../../types/restaurant/RestaurantOnboardingTypes';

const RestaurantOnboardingService = {
  getStatus: async (branchId: number) =>
    (await api.fetchCustom(`/branches/${branchId}`))
      .data as CustomResponse<RestaurantOnboardingStatus>,
};

export default RestaurantOnboardingService;
